import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { tagsTypes } from "./tagsTypes";

const baseURL = "http://supplier-api.leisuretimeout.com/api/v1/";
// const baseURL = "https://supplier.dayoutdubai.com/apis/public/api/v1/";
// const baseURL = "http://supplier-api.leisuretimeout.com/apis/public/api/v1/";
const authKey = "DOD$uPpl!Error";

export const baseAPI = createApi({
  reducerPath: "DODBaseAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: baseURL,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("DODLoginToken");

      // If we have a token set in state, let's assume that we should be passing it.
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("authorization-key", authKey);
      return headers;
    },
  }),
  endpoints: (builder) => ({}),
  tagTypes: [tagsTypes.GET_USER_PROFILE],
});
